import React from "react";
import Modal from "../Modal";
import styled from "@emotion/styled";
import { DefaultButton } from "../../StyledComponents/Buttons/Buttons";
import { StyledModal } from "../../StyledComponents/Modals/Modals";

const ModalFooter = styled.div`
  text-align: right;
  flex-shrink: 0;
  padding: 10px 20px;
  background-color: #f9f9f9;
  border-top: 1px solid #ddd;
`;

const CancelButton = styled.button`
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  margin: 5px;
  &:hover {
    background-color: #5a6268;
  }
`;

const CardContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
`;

const Card = styled.div`
  display: flex;
  width: 100%;
  overflow: hidden;
  background: #fff;
`;

const ImageContainer = styled.div`
  flex: 0 1 40%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background: #FFFFFF;
`;

const ContentContainer = styled.div`
  padding: 20px;
  flex: 0 1 60%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const FrameName = styled.h3`
  margin: 0;
  margin-bottom: 15px;
  font-size: 1.5em;
  color: #333;
`;

const FrameDetail = styled.p`
  margin: 5px 0;
  color: #666;
  font-size: 1em;
`;

const FrameDetailTitle = styled.span`
  font-weight: bold;
  color: #333;
`;

export default function FrameModal({ showHideModal, isModalOpen, frame }) {
    return (
        <Modal open={isModalOpen}>
            <StyledModal>
                <CardContainer>
                    <Card>
                        <ImageContainer>
                            <img
                                src={`https://www.mcrsafetyeurope.com/${frame.Image_A}`}
                                alt="Frame"
                                style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                            />
                        </ImageContainer>
                        <ContentContainer>
                            <FrameName>{frame.frameName}</FrameName>
                            <FrameDetail>
                                <FrameDetailTitle>Material: </FrameDetailTitle>{frame.frameMaterial}
                            </FrameDetail>
                            <FrameDetail>
                                <FrameDetailTitle>Type: </FrameDetailTitle>{frame.frametype}
                            </FrameDetail>
                            <FrameDetail>
                                <FrameDetailTitle>Colour: </FrameDetailTitle>{frame.frameColour}
                            </FrameDetail>
                            <FrameDetail>
                                <FrameDetailTitle>Size: </FrameDetailTitle>{frame.frameSize}
                            </FrameDetail>
                            <FrameDetail>
                                <FrameDetailTitle>Temple Length: </FrameDetailTitle>{frame.frtemplength} mm
                            </FrameDetail>
                            <FrameDetail>
                                <FrameDetailTitle>Datum: </FrameDetailTitle>{frame.frdatum} mm
                            </FrameDetail>
                        </ContentContainer>
                    </Card>
                </CardContainer>
                <ModalFooter>
                    <DefaultButton onClick={() => window.open(frame.ImageUrl)}>Visit Webpage</DefaultButton>
                    <CancelButton onClick={showHideModal}>Close</CancelButton>
                </ModalFooter>
            </StyledModal>
        </Modal>
    );
}
